<li class="m-nav-sticky__item" matTooltip="Properties" matTooltipPosition="left" id="m_properties_quick_sidebar_toggle">
	<a href="javascript:;" target="_blank">
		<i class="la la-code-fork"></i>
	</a>
</li>
